import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './styles/theme.css';
import './styles/animations.css';
import './styles/mobile.css';
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { usePerformanceStore } from './stores/performance';

const app = createApp(App);
const pinia = createPinia();

// 注册虚拟滚动组件
app.component('RecycleScroller', RecycleScroller);

app.use(pinia);
app.use(router);

// 初始化性能监控
if (import.meta.env.DEV) {
  const perfStore = usePerformanceStore();
  perfStore.init();
}

app.mount('#app');
